module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/.6.11.6@babel-runtime/core-js/json/stringify.js
// module id = 83
// module chunks = 0